var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav_banner"},[_c('div',{staticClass:"about_nav"},_vm._l((_vm.navData),function(item,index){return _c('div',{key:item.name,class:['item',{selected_color:index === _vm.selected}],on:{"click":function($event){return _vm.getActive(index,item.path)}}},[_vm._v("\n     "+_vm._s(item.name)+"\n   ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0784b628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/nav.vue
// module id = null
// module chunks = 